var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2496 2.03734C18.5621 2.34241 17.8237 2.54864 17.0473 2.64134C17.8397 2.16686 18.4467 1.41498 18.7333 0.520112C17.9807 0.967162 17.1569 1.28189 16.2979 1.45061C15.5988 0.705459 14.6019 0.240234 13.4991 0.240234C11.3821 0.240234 9.66532 1.95637 9.66532 4.07453C9.66532 4.37465 9.69912 4.66744 9.7641 4.94856C6.57736 4.7884 3.75211 3.26192 1.86102 0.942427C1.53081 1.50891 1.3418 2.16755 1.3418 2.87029C1.3418 4.20039 2.01881 5.37394 3.0475 6.06138C2.43853 6.04251 1.84293 5.87814 1.31048 5.582V5.63046C1.31048 7.48839 2.63196 9.03758 4.38616 9.38992C4.06391 9.47821 3.72573 9.52434 3.37588 9.52434C3.12851 9.52434 2.88853 9.50093 2.65408 9.45683C3.14203 10.9796 4.55809 12.0881 6.23547 12.1194C4.92319 13.1481 3.26967 13.7613 1.47375 13.7613C1.16443 13.7613 0.858713 13.7429 0.558594 13.7067C2.25572 14.7949 4.27079 15.4302 6.43621 15.4302C13.4886 15.4302 17.3456 9.58759 17.3456 4.5208C17.3456 4.35445 17.342 4.18935 17.334 4.02484C18.0854 3.4813 18.7341 2.80829 19.2496 2.03734V2.03734Z",
    fill: "#DDDBF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.1e83e3cb316fac5e45ae05c65a770ba4.svg";
export { ForwardRef as ReactComponent };